/*
PLEASE USE THE SAMPLE BANNER BLOCK PROVIDED BELOW:

{
    bannerImage: '',
    bannerPosition: 1,
    link: '',
},

*/
document.addEventListener('Searchanise.Loaded', function () {
    (function ($) {
        function snizeAddCollectionBanner(snizeBannerUrl, snizeBannerPosition, snizeColUrl) {
            if (location.pathname.includes('/collections')) {
                $(`ul.snize-search-results-content li:nth-child(${snizeBannerPosition})`).before(`
                    <li class="snize-banner snize-custom-banner">
                        ${snizeColUrl ? `<a href=${snizeColUrl} target="_blank">` : ''}
                        <img src=${snizeBannerUrl}></a></li>`
                );
            }
        }

        let snizeBannersData = [
            {
                bannerImage: 'https://cdn.shopify.com/s/files/1/0746/2702/3131/files/WW-Ether-Promo-Header-11-12.gif?v=1762556146',
                bannerPosition: 1,
                link: '/collections/wildcard',
            },
                       
        ];

        $(document).on('Searchanise.ResultsUpdated', function () {
            if (!$('.snize-custom-banner').length) {
                snizeBannersData.forEach(function (bannerData) {
                    snizeAddCollectionBanner(bannerData.bannerImage, bannerData.bannerPosition, bannerData.link);
                });
            }
        });
    })(window.Searchanise.$);
});